import React, { Suspense } from 'react';
import { Navigate } from "react-router-dom";

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

// const DialogRawMats = LazyLoadable(lazy(() => import('./purchase-contract-raw-mats/dialog-raw-mats/DialogRawMats')));
const PCATLRulesDialog = LazyLoadable(lazy(() => import('./maintenance/atl-rules/dialog/PCATLRulesDialog')));
const SendMailNew = LazyLoadable(lazy(() => import('./purchase-contract/dialog-raw-mats/SendMail')));
// const SendMail = LazyLoadable(lazy(() => import('./purchase-contract-raw-mats/dialog-raw-mats/SendMail')));
// const RawMatsCard = LazyLoadable(lazy(() => import("./purchase-contract-raw-mats/RawMatsCard")));
const ATLRulesCard = LazyLoadable(lazy(() => import("./maintenance/atl-rules/PurchaseContractAtlRulesCard")));
const RawMatsPurchaseContract = LazyLoadable(lazy(() => import("./purchase-contract/PurchaseContractCard")));
const RawMatsDialog = LazyLoadable(lazy(() => import('./purchase-contract/dialog-raw-mats/RawMatsDialog')));
const MaintenanceList = LazyLoadable(lazy(() => import('./maintenance/maintenace-list/MaintenanceList')))
const MailSettings = LazyLoadable(lazy(() => import('./maintenance/mail-settings/MailSettings')))

export const ROUTES_RAW_MATS = [
  {
    path: "/rawmats",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.RAW_MATS.module_name} /> </Suspense>,
    children: [
      {
        index: true,
        element: <Navigate to="purchasecontract" />,
      },
      {
        path: "purchasecontract/*",
        element: <RawMatsPurchaseContract />,
        children: [
          {
            path: ":uuid/*",
            element: <RawMatsDialog />,
            children: [
              {
                path: 'approvedetails/:noa_uuid',
                element: <SendMailNew />
              }
            ]
          },
        ]
      },
      // {
      //   path: "purchasecontracts/*",
      //   element: <RawMatsCard />,
      //   children: [
      //     {
      //       path: ":uuid/*",
      //       element: <DialogRawMats />,
      //       children: [
      //         {
      //           path: 'approvedetails/:noa_uuid',
      //           element: <SendMail />
      //         }
      //       ]
      //     },
      //   ]
      // },
      {
        path: "maintenance/mailsettings",
        element: <MailSettings />
      },
      {
        path: "maintenance/atlrules/*",
        element: <ATLRulesCard />,
        children: [
          {
            path: "new",
            element: <PCATLRulesDialog />
          },
          {
            path: ":atl_uuid",
            element: <PCATLRulesDialog />
          }
        ]
      },
      {
        path: "maintenance/lists/:list_type",
        element: <MaintenanceList />
      },
    ],
  },

];
